export const DOWNLOAD_PDF_FORM = "DOWNLOAD_PDF_FORM";
export const ADD_REFRAL = "ADD_REFRAL";